import React from "react";

export function Check({ checked, onChange, size = "md", testid, disabled }) {
  return (
    <button
      type="button"
      data-checked={!!checked}
      data-testid={testid}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) onChange?.(!checked);
      }}
      className={`ox-check ${size === "sm" ? "ox-check-sm" : ""}`}
      aria-pressed={!!checked}
    />
  );
}
